<template>
  <div>
    <details
        v-if="isOOW"
        ref="detailsElement"
        open
        class="warranty-details">
      <summary>Device is out of warranty</summary>
      <div class="warranty-content">
        <div
            v-if="warrantyEndsAt || oowReason"
            class="el-alert">
          <span v-if="warrantyEndsAt">Manufacturer warranty expiration date: <strong><time-zone-formatter
              output-format="DD MMMM, YYYY"
              :current-time="warrantyEndsAt" /></strong></span>
          <br>
          <span v-if="oowReason">Out of warranty reason: <strong>{{ oowReason }}</strong></span>
        </div>
        <p>
          Please review the <a
              href="https://ring.shelf.io/read/a8503948-f99e-4c1f-9703-ab25efef0f4b"
              target="_blank">OOW Support Page</a> and offer the neighbor an out of warranty discount code.
        </p>
      </div>
    </details>
    <div
        v-for="text in filteredRestrictions"
        :key="text"
        class="restriction-item">
      <span class="custom-square restriction-text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
import TimeZoneFormatter from "../../components/TimeZoneFormatter.vue";

export default {
  name: "DeviceRestrictionDetails",
  components: {
    TimeZoneFormatter,
  },
  props: {
    warrantyEndsAt: {
      type: String,
      default: null,
    },
    oowReason: {
      type: String,
      default: null,
    },
    restrictions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isOOW() {
      return !!this.restrictions.find(
        (restriction) => restriction.match(/is out of warranty/i) !== null
      );
    },
    filteredRestrictions() {
      return this.restrictions.filter(
        (restriction) => !restriction.match(/is out of warranty/i)
      );
    },
  },
  updated() {
    if (this.isOOW && this.$refs.detailsElement) {
      this.$refs.detailsElement.open = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.warranty-details {
  font-size: 1rem;
  margin-left: -0.5em;
  max-width: fit-content;
  border: 1px solid gray;
  border-radius: 0.2rem;
  padding: 0.5rem;

  summary {
    list-style: none;
    cursor: pointer;
    &::-webkit-details-marker {
      display: none;
    }

    &::before {
      content: "▶";
      margin-right: 4px;
      font-size: 0.7rem;
    }
  }

  &[open] {
    summary {
      margin-bottom: 0.5rem;
      &::before {
        content: "▼";
      }
    }
  }
}

.warranty-content {
  word-break: break-word;
  hyphens: auto;

  p {
    margin-left: 1em;
  }
  strong {
    font-weight: 600;
  }
  a {
    font-weight: 400;
  }
}

.el-alert {
  max-width: fit-content;
  text-align: left;
  display: inline-block;
  background: #eaeaea;
  font-size: 0.9em;
  padding: 16px 15px;
  margin-top: 5px;
  margin-left: 1em;
}

.oow-info-icon {
  color: #909399;
}

.custom-square {
  &::before {
    content: "•"; /* Bullet point */
    display: inline-block;
    position: relative;
    font-size: 2em;
    margin-right: 0.2em;
    margin-left: -0.05em;
    line-height: 1em;
    vertical-align: middle;
    top: -0.1em;
  }
}

.restriction-item {
  display: flex;
  align-items: center;

  .restriction-text {
    font-size: 1rem;
    line-height: 1.5;
  }
}
</style>
